var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('img',{staticClass:"pay-img",attrs:{"src":_vm.img,"alt":""}}),_c('span',[_vm._v("请使用微信扫描二维码进行支付")]),_c('el-button',{staticStyle:{"margin-top":"30px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlePay}},[_vm._v("支付完成")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }